import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../../authConfig";
import "./welcomeScreen.css";
import Logo from "../../Assets/image/fvLogo.svg";
import Patient from "../../Assets/image/welcome-patient.png";
import microLogo from "../../Assets/image/microsoft.png";
import Twitter from "../../Assets/Icons/twitterr.png";
import Facebook from "../../Assets/Icons/facebook.png";
import linkedin from "../../Assets/Icons/linkedin.png";
import authService from "../../services/authService";
import { useNavigate } from "react-router-dom";
import strings from "../../utils/strings";
import Widgets from "../../widgets";
import { useTranslation } from "react-i18next";
import packageJson from "../../../package.json";

const WelcomeScreen = () => {
  const { instance } = useMsal();
  const nav = useNavigate();
  const { t } = useTranslation();

  const handleLogin = () => {
    instance
      .loginPopup(loginRequest)
      .then((response) => {
        authService.setToken(response.accessToken);
        authService.setAdminName(response.account.name);

        const loginTimestamp = new Date().getTime();
        authService.setLoginTime(loginTimestamp);

        const clearTime = 59 * 60 * 1000;
        authService.setClearTime(loginTimestamp + clearTime);

        // nav(strings.navigation.patientProfile);
      })
      .catch((e) => {
        console.error("Login failed", e);
      });
  };

  const handleLogout = () => {};

  return (
    <div className="welcome-main">
      <div className="welcome-contaienr">
        <div className="welcome-left">
          <div>
            <div>
              <img src={Logo} alt="fv" className="welcome-logo" />
            </div>
            <div>
              <img src={Patient} alt="patient" className="welcome-patient" />
            </div>
          </div>
        </div>
        <div className="welcome-right">
          <div className="welcome-login-box">
            <div className="welcome-login-body">
              <div className="h1-lng">
                <p className="welcome-h1">{t("welcome")}</p>
                <Widgets.LanguageSwitcher />
              </div>
              <p className="welcome-description">{t("welocmeDescription")}</p>
              <div className="welcome-microsoft" onClick={handleLogin}>
                <img src={microLogo} alt="microsoft" />
                <div className="welcome-login">{t("loginWithMicrosoft")}</div>
              </div>
            </div>
            <div className="bottom-box">
              <div className="welcome-login-footer">
                {/* <div className="welcome-icon-ring">
                  <a href="https://twitter.com/yourProfile" target="_blank" rel="noopener noreferrer">
                    <img src={Twitter} alt="twitter" className="twitter-logo" />
                  </a>
                </div> */}
                <div className="welcome-icon-ring">
                  <a href="https://www.facebook.com/FVHospitalHCM" target="_blank" rel="noopener noreferrer">
                    <img src={Facebook} alt="facebook" />
                  </a>
                </div>
                <div className="welcome-icon-ring">
                  <a href="https://www.linkedin.com/company/fv-hospital-vietnam/" target="_blank" rel="noopener noreferrer">
                    <img src={linkedin} alt="linkedin" />
                  </a>
                </div>
              </div>
              <div>
                {t("version")} {packageJson.version}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WelcomeScreen;
